import { useContext } from "react";
import { ChatContext } from "../../contexts/ChatContext";
import ChatHeader from "../../components/chat/ChatHeader";
import ChatMessages from "../../components/chat/ChatMessages";
import ChatInput from "../../components/chat/ChatInput";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

export default function ChatPanel() {
  const { chatEnabled } = useContext(ChatContext);

  if (!chatEnabled) return null;

  return (
    <Container
      id="chat-panel"
      sx={{
        pt: { xs: 2, sm: 4 },
        pb: { xs: 2, sm: 4 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 2, sm: 3 },
      }}
    >
      <Typography
        component="h2"
        variant="h5"
        sx={{
          color: "text.primary",
          width: { sm: "100%", md: "60%" },
          textAlign: { sm: "left", md: "center" },
        }}
      >
        Ask the Support Assistant
      </Typography>
      <Paper
        elevation={2}
        sx={{
          width: "100%",
          height: { xs: 400, sm: 500 },
          display: "flex",
          flexDirection: "column",
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <ChatHeader showClose={false} />
        <ChatMessages />
        <ChatInput />
      </Paper>
    </Container>
  );
}
